import i18n from '@/lang';
import { saveAs } from 'file-saver';
const ExcelJs = require('exceljs');

// 分区
const obj = {
  header: '*' + i18n.t('basicData.PartitionName'), // 分区
  key: 'partitionAffiliateId',
  width: 30
};

/**
 * 生成模板
 * @param {any[]} partitionList 分区列表
 * @param expenseTypeList 费用类型
 * @param specialFeeList 特殊费用类型
 * @param partitionId 分区ID
 * @param type
 * @returns {ExcelJs.Workbook}
 */
const createTemplate = (partitionList, expenseTypeList, specialFeeList, partitionId = '', type = null) => {
  const wb = new ExcelJs.Workbook();
  try {
    if (type === 2) {
      const Sheet1 = wb.addWorksheet(i18n.t('basicData.PriceDetails')); // 价格详情
      const Sheet2 = wb.addWorksheet(i18n.t('basicData.otherRules')); // 其他规则
      const Sheet3 = wb.addWorksheet('Sheet3'); // 分区
      const Sheet4 = wb.addWorksheet('Sheet4'); // 普通费用
      const Sheet5 = wb.addWorksheet('Sheet5'); // 特殊费用

      const columns = [
        {
          header: '*' + i18n.t('basicData.ExpenseType'), // 费用类型
          key: 'feeTypeCode',
          width: 30
        },
        {
          header: '*' + i18n.t('basicData.WeightStartKG'), // 重量开始KG(不包含)
          key: 'startWeight',
          width: 30
        },
        {
          header: '*' + i18n.t('basicData.WeightEndKG'), // 重量结束KG(包含)
          key: 'endWeight',
          width: 30
        },
        {
          header: '*' + '0-31KM' + i18n.t('basicData.Price'), // 0-31KM价格
          key: 'innerDistancePrice',
          width: 30
        },
        {
          header: '31-101KM' + i18n.t('basicData.Price'), // 31-101KM价格
          key: 'outerDistancePrice',
          width: 30
        },
        {
          header: '>=101KM' + i18n.t('basicData.Price'), // >=101KM价格
          key: 'greaterThanDistancePrice',
          width: 30
        },
        {
          header: '0-31KM' + i18n.t('basicData.ExcessWeightFareIncrease'), // 0-31KM超出重量加价(每KG)
          key: 'overWeightExtraPrice',
          width: 30
        },
        {
          header: '31-101KM' + i18n.t('basicData.ExcessWeightFareIncrease'), // 31-101KM超出重量加价（每KG）
          key: 'overKilometerExtraPrice',
          width: 30
        },
        {
          header: '>=101KM' + i18n.t('basicData.ExcessWeightFareIncrease'), // >=101KM超出重量加价（每KG）
          key: 'greaterThanKilometerExtraPrice',
          width: 30
        }
      ];
      const columnsRules = [
        {
          header: '*' + i18n.t('basicData.ExpenseType'), // 费用类型
          key: 'feeTypeCode',
          width: 30
        },
        {
          header: '*' + i18n.t('basicData.BillingRules') + '(%)', // 计费规则
          key: 'deliveryFeeRatio',
          width: 30
        }
      ];
      if (partitionId) {
        columns.unshift(obj);
        columnsRules.unshift(obj);
      }
      Sheet1.columns = columns;
      Sheet2.columns = columnsRules;
      Sheet1.mergeCells('A2:M2');
      Sheet1.getCell('A2').value = `
          1、每次仅导入 10000 条 /Importar apenas 10000 itens de cada vez
          2、必填 /Obrigatório
          3、不可更改此模板 /Esse modelo não pode ser alterado
        `;
      Sheet1.getRow(1).font = {
        color: { argb: '000000' },
        bold: true
      };
      Sheet1.getRow(2).getCell(1).font = {
        color: { argb: 'ff0000' }
      };
      Sheet2.getRow(1).font = {
        color: { argb: '000000' },
        bold: true
      };
      // 分区
      Sheet3.columns = [
        {
          header: i18n.t('basicData.PartitionName'), // 分区
          key: 'partitionIdentifier',
          width: 20
        },
        {
          header: i18n.t('basicData.PartitionName') + '(ID)', // 分区
          key: 'partitionAffiliateId',
          width: 20
        }
      ];
      const Sheet3_data = [];
      (partitionList || []).map((item) => {
        Sheet3_data.push({
          partitionAffiliateId: item.id,
          partitionIdentifier: item.partitionIdentifier + '-' + item.id
        });
      });
      Sheet3.addRows(Sheet3_data);
      // 费用
      const feeColumns = [
        {
          header: i18n.t('basicData.ExpenseType') + '(' + i18n.t('ChannelManage.name') + ')', // 费用类型
          key: 'feeTypeName',
          width: 20
        },
        {
          header: i18n.t('basicData.ExpenseType') + '(code)', // 费用类型
          key: 'feeTypeCode',
          width: 20
        }
      ];
      Sheet4.columns = feeColumns;
      Sheet5.columns = feeColumns;
      const Sheet4_data = [];
      (expenseTypeList || []).map((item) => {
        Sheet4_data.push({
          feeTypeCode: item.code,
          feeTypeName: item.displayName + '-' + item.code
        });
      });
      Sheet4.addRows(Sheet4_data);
      // 特殊费用
      const Sheet5_data = [];
      (specialFeeList || []).map((item) => {
        Sheet5_data.push({
          feeTypeCode: item.code,
          feeTypeName: item.displayName + '-' + item.code
        });
      });
      Sheet5.addRows(Sheet5_data);

      new Array(10000).fill(0).forEach((_, idx) => {
        const row = idx + 2;
        const rows = idx + 3;
        try {
          if (partitionId) {
            // 分区
            Sheet1.getCell(rows, 1).dataValidation = {
              type: 'list',
              formulae: [`=Sheet3!$A$2:$A${Sheet3_data.length + 1}`]
            };
            Sheet2.getCell(row, 1).dataValidation = {
              type: 'list',
              formulae: [`=Sheet3!$A$2:$A${Sheet3_data.length + 1}`]
            };
          }

          const idx = partitionId ? 2 : 1;
          // 费用类型
          Sheet1.getCell(rows, idx).dataValidation = {
            type: 'list',
            formulae: [`=Sheet4!$A$2:$A${Sheet4_data.length + 1}`]
          };
          Sheet2.getCell(row, idx).dataValidation = {
            type: 'list',
            formulae: [`=Sheet5!$A$2:$A${Sheet5_data.length + 1}`]
          };
        } catch (error) {
          console.log(error);
        }
      });
    } else {
      const sheet = wb.addWorksheet('Sheet');
      sheet.columns = [
        {
          header: '应付主体',
          key: 'providerCode',
          width: 40
        },
        {
          header: '网点',
          key: 'siteName',
          width: 40
        }
      ];
      sheet.getCell('A2').value = 'Entidade a Pagar';
      sheet.getCell('B2').value = 'Agência';
      sheet.getRow(1).font = {
        color: { argb: '000000' },
        bold: true
      };
      sheet.getRow(2).font = {
        color: { argb: '000000' },
        bold: true
      };
      sheet.mergeCells('A3:B3');
      sheet.getRow(3).height = 50; // 设置行高
      sheet.getRow(3).getCell(1).style = {
        // 设置单元格样式
        font: {
          color: { argb: 'ff0000' }
        },
        alignment: {
          vertical: 'center', // 垂直居中
          horizontal: 'left', // 水平左对齐
          wrapText: true, // 自动换行
          indent: 0 // 禁止缩进
        }
      };
      sheet.getCell('A3').value = `
          1、每次仅导入 10000 条 /Importar apenas 10000 itens de cada vez
          2、必填 /Obrigatório
          3、不可更改此模板 /Esse modelo não pode ser alterado
        `;
    }
  } catch (error) {
    console.log(error);
  }
  return wb;
};

const getHeaderObj = () => {
  // 国际化键常量
  const PARTITION_NAME_KEY = 'basicData.PartitionName';
  const EXPENSE_TYPE_KEY = 'basicData.ExpenseType';
  const WEIGHT_START_KG_KEY = 'basicData.WeightStartKG';
  const WEIGHT_END_KG_KEY = 'basicData.WeightEndKG';
  const PRICE_KEY = 'basicData.Price';
  const EXCESS_WEIGHT_FARE_INCREASE_KEY = 'basicData.ExcessWeightFareIncrease';
  const BILLING_RULES_KEY = 'basicData.BillingRules';

  // 安全地获取翻译值并设置默认值以防丢失
  function getI18nValue(key, defaultValue = '') {
    try {
      const value = i18n.t(key);
      return value || defaultValue;
    } catch (e) {
      console.warn(`Failed to load i18n key: ${key}`, e);
      return defaultValue;
    }
  }

  // 获取基础字段翻译
  const partitionName = getI18nValue(PARTITION_NAME_KEY, '分区名称');
  const expenseType = getI18nValue(EXPENSE_TYPE_KEY, '费用类型');
  const weightStartKG = getI18nValue(WEIGHT_START_KG_KEY, '起始重量(KG)');
  const weightEndKG = getI18nValue(WEIGHT_END_KG_KEY, '结束重量(KG)');
  const priceKey = getI18nValue(PRICE_KEY, '价格');
  const excessWeightFareIncrease = getI18nValue(EXCESS_WEIGHT_FARE_INCREASE_KEY, '超重加价');
  const billingRules = getI18nValue(BILLING_RULES_KEY, '计费规则');

  // 距离区间配置
  const distanceRanges = [
    { label: '0-31KM', innerPriceField: 'innerDistancePrice', overWeightField: 'overWeightExtraPrice' },
    { label: '31-101KM', outerPriceField: 'outerDistancePrice', overKmField: 'overKilometerExtraPrice' },
    { label: '>=101KM', greaterPriceField: 'greaterThanDistancePrice', greaterOverKmField: 'greaterThanKilometerExtraPrice' }
  ];

  // 构建 header 映射对象
  const headerObj = {
    ['*' + partitionName]: 'partitionAffiliateId',
    ['*' + expenseType]: 'feeTypeCode',
    ['*' + weightStartKG]: 'startWeight',
    ['*' + weightEndKG]: 'endWeight'
  };

  distanceRanges.forEach(range => {
    if (range.innerPriceField) {
      headerObj['*' + range.label + priceKey] = range.innerPriceField;
    }
    if (range.outerPriceField) {
      headerObj[range.label + priceKey] = range.outerPriceField;
    }
    if (range.greaterPriceField) {
      headerObj[range.label + priceKey] = range.greaterPriceField;
    }

    if (range.overWeightField) {
      headerObj[range.label + excessWeightFareIncrease] = range.overWeightField;
    }
    if (range.overKmField) {
      headerObj[range.label + excessWeightFareIncrease] = range.overKmField;
    }
    if (range.greaterOverKmField) {
      headerObj[range.label + excessWeightFareIncrease] = range.greaterOverKmField;
    }
  });

  headerObj['*' + billingRules + '(%)'] = 'deliveryFeeRatio';
  return headerObj;
};

export const { downloadTemplate, importLogistics } = (() => {
  /**
   * 导出模板
   * @param {Array} partitionList 分区列表
   * @param {Array} expenseTypeList 费用类型列表
   * @param {Array} specialFeeList 特殊费用类型列表
   * @param {Number} partitionId 分区方案D
   * @param {Number} type 模板类型
   */
  const downloadTemplate = async(partitionList, expenseTypeList, specialFeeList, partitionId, type) => {
    const wb = createTemplate(partitionList, expenseTypeList, specialFeeList, partitionId, type);
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/octet-stream'
    });
    const fileName = type === 1 ? i18n.t('basicData.ImportMainTemplate') : `DSP${i18n.t('basicData.ImportQuotationTemplatesInBulk')}`;
    saveAs(blob, `${fileName}.xlsx`);
  };

  /**
   * 导入模板
   * @param formData 表单数据
   * @param data 普通规则
   * @param rulesData 特殊规则
   */
  const importLogistics = (formData, data, rulesData) => {
    const headerObj = getHeaderObj();

    const list = data.results.slice(1);
    const rulesList = rulesData.results;

    // 公共函数
    const transformList = (items) => {
      const result = [];
      items.forEach(item => {
        try {
          const obj = {};
          Object.keys(item).forEach((key) => {
            const fieldKey = headerObj[key];
            if (fieldKey && ['partitionAffiliateId', 'feeTypeCode'].includes(fieldKey)) {
              const value = item[key];
              obj[fieldKey] = typeof value === 'string' ? value.split('-').pop() || '' : String(value || '');
            } else {
              obj[fieldKey] = item[key];
            }
          });
          result.push(obj);
        } catch (e) {
          console.log('Error processing item:', item, e);
        }
      });
      return result;
    };

    const arr = transformList(list);
    const rulesArr = transformList(rulesList);

    return {
      arr,
      rulesArr
    };
  };

  return {
    downloadTemplate,
    importLogistics
  };
})();

// 规则校验
export const priceType = (rule, value, callback) => {
  const { required, negative2 } = rule;
  const reg = negative2 === 9 // mdd校验
    ? /^-?\d+(\.\d{1,2})?$/
    : new RegExp(`(^${rule.negative}[1-9]\\d*(\\.\\d{1,${rule.suffix}})?$)|(^${rule.negative}0(\\.\\d{1,${rule.suffix}})?$)`);

  if (!required && !value) {
    callback();
    return;
  }

  if (value === '') {
    callback(new Error(i18n.t('basicData.CannotBeEmpty')));
    return;
  }

  if (!reg.test(value)) {
    callback(new Error(i18n.t('basicData.NumericWithTwoDecimals')));
    return;
  }

  if (rule.package) {
    const numValue = parseFloat(value);
    const numPackage = parseFloat(rule.package);

    if (rule.negative1 === 2) {
      if (numValue <= numPackage) {
        callback(new Error(i18n.t('basicData.MustGreaterThanStartingValue')));
        return;
      }
      if (numValue <= 0) {
        callback(new Error(i18n.t('basicData.MustBeGreaterThan0')));
        return;
      }
    } else if (numValue >= numPackage) {
      callback(new Error(i18n.t('basicData.MustLessThanEndValue')));
      return;
    }
  }

  callback();
};

export const Integer0 = (rule, value, callback) => {
  const reg = rule.negative === 1 ? /(^[1-9]\d*$)/ : /(^[0-9]\d*$)/;

  if (!rule.required) {
    callback();
    return;
  }

  if (value === '') {
    callback(new Error(i18n.t('basicData.CannotBeEmpty')));
    return;
  }

  if (!reg.test(value)) {
    const message = rule.negative === 1
      ? i18n.t('basicData.MustPositiveIntegerGreaterThan0')
      : i18n.t('basicData.MustPositiveIntegerGreaterThanOrEqual0');
    callback(new Error(message));
    return;
  }

  if (rule.package) {
    const numValue = parseFloat(value);
    const numPackage = parseFloat(rule.package);

    if (rule.negative1 === 2 && numValue <= numPackage) {
      callback(new Error(i18n.t('basicData.MustGreaterThanStartingValue')));
      return;
    } else if (rule.negative1 !== 2 && numValue >= numPackage) {
      callback(new Error(i18n.t('basicData.MustLessThanEndValue')));
      return;
    }
  }

  callback();
};
